import React from 'react';
import ReactDOM from 'react-dom';
import ContestLanding from '../../views/common/ContestLanding';
import HmAjax from '../../util/HmAjax';
import FileUpload from '../../components/fileLoader/FileUpload';
import $ from 'jquery';
import PendingRegTable from './PendingRegTable';
import RegUsersTable from './RegUsersTable';
import ReactHtmlParser from 'react-html-parser';
import HmEventRegistry from '../../model/HmEventRegistry';

const pendingRegistrationView = "pendingRegistrationView";
const registeredUsersView = "registeredUsersView";

class Registration extends ContestLanding{
	constructor() {
    super();
    
    this.state = {
      dataLoaded:false,
      topicSubView:pendingRegistrationView,
      pendRegDataLoaded:true,
      regUsersDataLoaded:true,
      noProducts:false,
      trackId:null,
      registeredCount: 0,
      pendingCount: 0,
      fileUpLoaded:false,
      RegistrationOpen:false,
      regCheckDone:false,
      regnEndDate:null
      };

    this.dashboardDropDownKey = "homeDropdown";
    this.handleFileChange = this.handleFileChange.bind(this);
    this.topicPointClick =this.topicPointClick.bind(this);
    this.switchRegTab = this.switchRegTab.bind(this);
    this.getCount = this.getCount.bind(this);
    this.productsAvailableToAccess = this.productsAvailableToAccess.bind(this);
    this.setChild(this,"CONTEST");

    this.getPendingUserCount = this.getPendingUserCount.bind(this);
  }

  componentDidMount(){

   var me=this;
   super.componentDidMount();
   this.getRegistrationStatus();
   this.getCount();
   
   if(this.productsAvailableToAccess()){
        //this.setPreferredDd();
       // this.getGradeList();
     }else{
        //this.setState({noProducts:true});
      }
      this.setState({noProducts:true});
      this.fireMobileToast();
      //Eligible for last accessView
      this.setLastAccessView();
      HmEventRegistry.fireEvent("INITIATE_GA");
      HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
    } 

    getPendingUserCount(){
      return this.state.pendingCount;
    }

    productsAvailableToAccess(){
      var user = this.getUser();
      if(user != null){
       var permissions = user.getEntlHistory();
       if(permissions != null && Object.keys(permissions).length > 0){
        for(var i in permissions){
         if(permissions[i] != null){
          var totalLevel = permissions[i].split(",").reduce(function(a,b){
           try{
            return parseInt(a) + parseInt(b);
          }catch(e){
            return 0;
          }
        });

          if(totalLevel > 0){
           return true;
         }
       }
     }
   }
 }

 return false;
}

getRegistrationStatus(){
  let me=this;
    var callBackSuccess = function(response){
			
        if(response !== null){
         // console.log("RegistrationOpen ",response);
          let RegistrationOpen  = response.regnActive;
          if(RegistrationOpen){
            me.setState({regCheckDone:true,RegistrationOpen: true,regnEndDate:response.regnEndDate});    
          }else{
            me.setState({regCheckDone:true,RegistrationOpen: false,regnEndDate:response.regnEndDate,topicSubView:registeredUsersView});
          }
      }
    }


  var callBackFailure = function(response){
          //console.log("userRegisterForm failure",response);
        // me.setState({RegistrationOpen: false});
      }
      let contestId = (this.getSelectedContestGroup()) ? this.getSelectedContestGroup() : null;

      new HmAjax(this.getUrlFor("CONTEST_REGISTRATION_STATUS").replace("{#contestId}",contestId)).get(callBackSuccess, callBackFailure);
}

topicPointClick(event){
  var target = event.currentTarget;
  $(".hometopmenu").removeClass("selected");
  $(target).addClass("selected");

  if($(target).hasClass("allTopics")){
    this.setState({topicSubView:pendingRegistrationView});

  }else if($(target).hasClass("pointssystem")){				
    this.setState({topicSubView:registeredUsersView});
  }

}

switchRegTab(){
  try{
    $(".hometopmenu").removeClass("selected");
    this.setState({topicSubView:registeredUsersView});
    setTimeout(()=>{
      $(".pointssystem").addClass("selected");
    },100);
  }catch(e){

  }
}

handleFileChange(trackId,fileUpLoaded=false,usersListForUpload=null) {
       let me=this;
       me.setState({trackId:trackId,fileUpLoaded:fileUpLoaded});
        //console.log("handleFileChange Out");
        try{
          if(fileUpLoaded && usersListForUpload && ReactDOM.findDOMNode(me.refs.PendingComp)){
            //console.log("handleFileChange In");
            if(typeof me.refs.PendingComp.loadJson === "function"){
              me.refs.PendingComp.loadJson(usersListForUpload);
            }				
          }
        }catch(e){
          console.warn(e);
        }
      
     }

     pendingRegTab(){
      if(this.state.pendRegDataLoaded == true){
        let selected = this.state.RegistrationOpen ? " selected":"";
        return(
          <div className={"allTopics hometopmenu"+selected} data-ga="Pending tab" onClick={this.topicPointClick}>
          <span>{this.state.pendingCount}</span>
          {this.rb("contest.pendregtab")} 
          </div>
          );
        }
      }

      regUsersTab(){
        if(this.state.regUsersDataLoaded == true){
          let selected = !this.state.RegistrationOpen ? " selected":"";
          return(
          <div className={"pointssystem hometopmenu"+selected} data-ga="Registered tab" onClick={this.topicPointClick}>
          <span>{this.state.registeredCount}</span>
          {this.rb("contest.regusertab")} 
          </div>
          );
        }
      }

      getCount(forceLoad, callBack){
        let me = this;
        
        let success = (resp, opts) => {
          if(resp && resp.message === "success"){
            me.setState({registeredCount: (!isNaN(resp.registered) ? resp.registered : 0), pendingCount: (!isNaN(resp.pending) ? resp.pending : 0)});

            if(typeof callBack === "function"){
               callBack.apply(this, [resp]);
            }
          }
        }

        let failure = (err, opts) => {
          console.error("Error occurred while trying to fetch count.");           
        }
        //console.log("getCount abdul ",this.state.countLoaded ," :: ", forceLoad ," ::: ", this.countLoadTriggered);
         
        new HmAjax(this.getUrlFor("CONTEST_USERS_GET_COUNT").replace("{#contestId}",this.getSelectedContestGroup())).get(success, failure);
     
      }

      getRegistrationClosed(){
        let str =  this.state.regnEndDate || 0;
        let regClosedTime = this.epochTimeFn(str) +", "+this.formatAMPM(str)
        return regClosedTime;
      }

      render(){
        let me=this;
        return super.render(
        <div id="cont_reg" className="HomeComponent">

        {
          (()=>{

           if(this.state.regCheckDone){

            return(
            <div className="topicspointsheader">

            {this.pendingRegTab()}

            {this.regUsersTab()}

            </div> 
            )

          }

        })()
      }

      { 

        (()=>{
          if(this.state.topicSubView === pendingRegistrationView && this.state.regCheckDone){
            return(
            <div id="pointsContainer" className="homeTopicContainer">
            <FileUpload RegistrationOpen={this.state.RegistrationOpen} getCount={this.getCount} getUserCount={this.getPendingUserCount} contest_host={this.getSelectedContestGroup()} checktype="image" callback={this.handleFileChange} required/>
          <PendingRegTable switchRegTab={this.switchRegTab} ref={'PendingComp'} RegistrationOpen={this.state.RegistrationOpen} fileUpLoaded={this.state.fileUpLoaded} contest_host={this.getSelectedContestGroup()} getCount={me.getCount} trackId={me.state.trackId}></PendingRegTable>
          {
            (()=>{
                if(!me.state.RegistrationOpen && this.state.regCheckDone){
                  let userName = me.UserStore.getUserName() || me.UserStore.getLoginId();
                  return(
                    <div className="contregInfo">
                      <div>

                      <div className="contregPopup-body">
                      <div className="status"><i className="material-icons">
                    warning
                    </i>
                      <span>{me.rb("contest.reg.closed")}</span></div>

                      <div>Hello &nbsp;<span className="username">{userName}&nbsp;!</span></div> 

                        <div className="descrptn">
                        {me.rb("contest.reg.desc1")}  <br/>
                        {ReactHtmlParser(me.rb("contest.reg.desc2"))}
                          </div>
                        </div>
                        </div>
                    </div>    
                  )
                }
            })()
          }
          </div>
          )
        }
        else if(this.state.topicSubView === registeredUsersView){
          return(
          <div id="pointsContainer" className="homeTopicContainer">
          {
            (()=>{
              let regnEndDate = this.getRegistrationClosed();
              if(this.state.registeredCount && this.state.registeredCount>0){
                return(
                  <div className="reg-msg">{ReactHtmlParser(me.rb("contest.reguser.regcount",[this.state.registeredCount]))}
                  {/* <h3>You have successfully registered <span>{this.state.registeredCount}</span> students</h3> */}
                  </div>
                )
              }else{
               if(this.state.regnEndDate!==null){
                return(
                  <div className="reg-msg">{ReactHtmlParser(me.rb("contest.reguser.regenddate",[regnEndDate]))}
                  {/* <h3>Last date of registration: &nbsp;<span>{regnEndDate}</span></h3> */}
                  </div>
                )
               }
              }
            })()
          }
          <RegUsersTable RegistrationOpen={this.state.RegistrationOpen} contest_host={this.getSelectedContestGroup()} getCount={me.getCount} trackId={this.state.trackId}></RegUsersTable>
        </div>
        )
      }
      else{
        return(<div> {this.showLoader()} </div>)
      }       
    })()

  }

  </div>
  )
} 

}

export default Registration;


// WEBPACK FOOTER //
// ./src/views/registration/Registration.js